<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "DayCounter"
}
</script>

<style scoped>

</style>